// extracted by mini-css-extract-plugin
export default {"input_wrapper":"SearchInput_input_wrapper__AfHLC","input":"SearchInput_input__ZcAsu","search_icon":"SearchInput_search_icon__AkWiv"};